<template>
  <!-- app-header -->
  <div class="app-header">
    <div class="app-header__logo">
      <a href="/" class="logo-src"></a>
      <div class="header__pane ml-auto">
        <div>
          <button type="button" class="hamburger close-sidebar-btn hamburger--elastic" data-class="closed-sidebar">
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="app-header__mobile-menu">
      <div>
        <button type="button" class="hamburger hamburger--elastic mobile-toggle-nav" @click.stop.prevent="toggleSidebar">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </div>
    </div>
  </div>
  <!-- #app-header -->
</template>

<script>
export default {
  mounted() {
    document.querySelector('#main-container').classList.remove('sidebar-mobile-open')
    document.querySelector('.app-header__mobile-menu .mobile-toggle-nav').classList.remove('is-active')
  },
  methods: {
    toggleSidebar(e) {
      let $el = document.querySelector('#main-container')
      $el.classList.toggle('sidebar-mobile-open')
      if ($el.classList.contains('sidebar-mobile-open')) {
        e.currentTarget.classList.add('is-active')
      } else {
        e.currentTarget.classList.remove('is-active')
      }
    }
  }
}
</script>
